import ISalesProductPrice from "@/interfaces/sales-product-price.interfaces";
import { FilterType, IFilter } from "@/types/filter.types";

export const pageNumber = 1;
export const pageSize = 100;

export function getInitialFilterValues(salesProductId: number): IFilter<ISalesProductPrice>[] {
  return [
    {
      property: "salesProductId",
      value: salesProductId,
      filterType: FilterType.Equals,
    },
  ];
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getInitialSalesProductFilterValues(): IFilter<any>[] {
  return [
    {
      property: "Status",
      value: "A",
      filterType: FilterType.Equals,
    },
  ];
}
